import script from "./icon-hint.vue?vue&type=script&setup=true&lang=js"
export * from "./icon-hint.vue?vue&type=script&setup=true&lang=js"

import "./icon-hint.vue?vue&type=style&index=0&id=e77e4888&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e77e4888"]])

export default __exports__